<template>
  <form>
    <div class="box">
      <nav class="level">
        <div class="level-left">
          <h3 class="subTitle">{{title}}</h3>
        </div>
      </nav>
      <section class="panel">
        <div class="panel-heading">Tipos</div>
        <div class="panel-block d-block px-0 py-2">
          <div class="container">
            <div class="row">
              <div class="col-12" v-if="showContent">
                <ContentLoading
                  :show="showContent"
                  :grid="grid"
                  :width="415"
                  :height="18"
                  :mobile-grid="mobileGrid"
                  :mobile-width="30"
                  :mobile-height="15"
                />
                <p class="text-loading ml-2">Aguarde ...</p>
              </div>
              <div class="col-12" v-else>
                <div v-for="(item, index) in formTypes" :key="index" class="field row mb-0" :class="{ 'border-0' : index == formTypes.length - 1 }">
                  <div class="col-md-3 col-12 mb-md-0 mb-3">
                    <InputText class="tableInputConfig" name="id" label="ID" :disabled="true" :currentValue="item.id" :index="index" @set="setType" />
                  </div>
                  <div class="col-md-3 col-12 mb-md-0 mb-3">
                    <InputText class="tableInputConfig" name="name" label="Label" :currentValue="item.name" :index="index" @set="setType" />
                  </div>
                  <div class="col-md-3 col-12">
                    <InputSelect class="tableLineConfig" label="Status" name="status" :currentValue="item.status" :items="status" :index="index" @set="setType"  />
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      </section>
      <section class="panel">
        <div class="panel-heading">Campos</div>
        <div class="panel-block d-block px-0 py-2">
          <div class="container">
            <div class="row">
              <div class="col-12" v-if="showContent">
                <ContentLoading
                  :show="showContent"
                  :grid="grid"
                  :width="415"
                  :height="18"
                  :mobile-grid="mobileGrid"
                  :mobile-width="30"
                  :mobile-height="35"
                />
                <p class="text-loading ml-2">Aguarde ...</p>
              </div>
              <div class="col-12" v-else>
                <div v-for="(item, index) in formFields" :key="index" class="field row mb-0" :class="{ 'border-0' : index == formFields.length - 1 }">
                  <div class="col-md-3 col-12 mb-md-0 mb-3">
                    <InputText class="tableInputConfig" name="id" label="ID" :disabled="true" :currentValue="item.id" :index="index" @set="setField" />
                  </div> 
                  <div class="col-md-3 col-12 mb-md-0 mb-3">
                    <InputText class="tableInputConfig" name="name" label="Label" :currentValue="item.name" :index="index" @set="setField" />
                  </div>
                  <div class="col-md-3 col-12 mb-md-0 mb-3">
                    <InputSelect class="tableLineConfig" label="Tipo" name="format" :currentValue="item.format" :items="dataTypes" :index="index" @set="setField"  />
                  </div>
                  <div class="col-md-3 col-12">
                    <InputSelect class="tableLineConfig mb-" label="Status" name="status" :currentValue="item.status" :items="status" :index="index" @set="setField"  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="level-right pt-3 pb-5 mb-2">
      <Button  @event="back" name="Voltar" />
      <Button  :disabled="false" @event="formSubmit" name="Salvar" />
    </div>
  </form>
</template>

<script>
import ContentLoading from '@/components/helpers/ContentLoading'
import { InputText,InputSelect, Button } from '@/components/form'
import { mapState } from 'vuex'

export default {
  name: 'ConfigurationsForm',
  components: {
    Button,
    InputText,
    InputSelect,
    ContentLoading
  },
  data: () => ({
    formTypes: [],
    formFields: [],
    dataTypes: [],
    status: [
      {
        id: 'active',
        name: 'Ativo'
      },
      {
        id: 'inactive',
        name: 'Inativo'
      }
    ],
    showContent: true,
    grid: [
      { x: 0, y: 0, rx: 2, ry: 2, innerWidth: 100, innerHeight: 18 },
      { x: 105, y: 0, rx: 2, ry: 2, innerWidth: 100, innerHeight: 18 },
      { x: 210, y: 0, rx: 2, ry: 2, innerWidth: 100, innerHeight: 18 },
      { x: 315, y: 0, rx: 2, ry: 2, innerWidth: 100, innerHeight: 18 }
    ],
    mobileGrid: [
      { x: 0, y: 0, rx: 1, ry: 1, innerWidth: 30, innerHeight: 8 },
      { x: 0, y: 9, rx: 1, ry: 1, innerWidth: 30, innerHeight: 8 },
      { x: 0, y: 18, rx: 1, ry: 1, innerWidth: 30, innerHeight: 8 },
      { x: 0, y: 27, rx: 1, ry: 1, innerWidth: 30, innerHeight: 8 }
    ]
  }),
  props: {
    title: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ''
    },
    types: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    setField({ name, item, value, index }) {
      this.set({ field: 'formFields', name, item, value, index })
    },
    setType({ name, item, value, index }) {
      this.set({ field: 'formTypes', name, item, value, index })
    },
    set({ field, name, item, value, index }) {
      if (index !== null) {
        this[field] = this[field].map((current, key) => {
          return index === key
            ? { ...current, [name]: item ? item.id : value }
            : current
        })
      }
    },
    formSubmit() {
      const payload = [
        ...this.formTypes,
        ...this.formFields
      ]
      this.showContent = true
      this.$emit('submit', payload)
    }
  },
  computed: {
    ...mapState(['configurations'])
  },
  mounted() {
    this.dataTypes = Object.keys(this.configurations.operatorsByType).map(value => ({ id: value, name: value }))
  },
  watch: {
    types: {
      immediate: false,
      deep: true,
      handler (value) {
        this.formTypes = [
          ...this.formTypes,
          ...value
        ],
        this.showContent = false
      }
    },
    fields: {
      immediate: false,
      deep: true,
      handler (value) {
        this.formFields = [
          ...this.formFields,
          ...value
        ],
        this.showContent = false
      }
    }
  },
};
</script>

<style lang="scss">
.tableLineConfig{
  color: rgb(203, 203, 211);
}
.field{
  &.row{
    border-bottom: 1px solid #dbdbdb;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  label{
    color: #6D6D77;
  }
}



</style>